$(document).ready(function() {
  $(".veranderkommainpunt").change(
    function() {
       var t = $(this).val();
       t = t.replace(',', '.');
       $(this).val(t);
    }
  );
});

